import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import CadastroContainer from "../../../../components/CadastroContainer/CadastroContainer";
import FormPoliticas from "../FormPoliticas/FormPoliticas";
import "./CadastroPoliticas.css";
import PolicyService from "../../../../services/PoliciesService";

const CadastroPoliticas = () => {
	const { policyId } = useParams();
	const { state } = useLocation();
	const [politica, setPolitica] = useState(state);
	const [type, setType] = useState("");

	async function loadPolicy(id) {
		const response = await PolicyService.getPolicy(id);
		if (response.data) {
			setPolitica(response.data);
		}
	}

	useEffect(() => {
		setType(policyId || state ? "edicao" : "cadastro");

		if (politica) {
			setPolitica(state);
			return;
		}

		if (policyId) {
			loadPolicy(policyId);
		}
	}, [state, policyId]);

	return (
		<CadastroContainer>
			<FormPoliticas politica={politica} type={type} />
		</CadastroContainer>
	);
};

export default CadastroPoliticas;
